import { Component, DestroyRef, inject, OnInit, signal } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";

import { componentDestroyed } from "ng2-rx-componentdestroyed";
import { share, takeUntil } from "rxjs/operators";
import Swal from "sweetalert2";

import { CommonService } from "@services/common.service";
import { SharedService } from "@services/shared.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  selector: "app-newsletter",
  templateUrl: "./newsletter.component.html",
  styleUrls: ["./newsletter.component.scss"],
})
export class NewsletterComponent implements OnInit {
  emailSubsribeForm: UntypedFormGroup;
  postobj = signal<any | null>(null);
  geoLocationInfo = signal<any | null>(null);
  emailSub = signal<string>("");
  userId = signal<string>("");
  emailReq = signal(false);
  private destroyRef = inject(DestroyRef);

  private readonly fb = inject(UntypedFormBuilder);
  private readonly commonService = inject(CommonService);
  private readonly sharedService = inject(SharedService);

  // constructor(
  //   private fb: UntypedFormBuilder,
  //   private commonService: CommonService,
  //   private sharedService: SharedService,
  // ) {}

  ngOnInit() {
    this.emailSubsribeForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
    });

    this.commonService.EMAILSUBSCRIPTION.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((subscriptionres) => {
      this.emailReq.set(false);
      if (subscriptionres && subscriptionres.result) {
        this.emailSub.set(subscriptionres.result);
        Swal.fire({
          title: this.emailSub(),
          allowOutsideClick: false,
        }).then((ok) => {
          this.emailSubsribeForm.reset();
        });
        setTimeout(() => {}, 6000);
      }
    });
    this.sharedService.GeoLocationParam.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((geoData) => {
      if (geoData) {
        this.geoLocationInfo.set(geoData);
      }
    });

    /**
     * This is used to fetch user Id from local storage for loggedd in user
     */

    // this.sharedService.loginUserId$.subscribe(userId => {
    //   if (userId) {
    //     this.userId = userId;
    //   }
    // });

    this.sharedService.userDetailsParam
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((userDataObj) => {
        if (userDataObj != null && userDataObj != undefined) {
          if (userDataObj) {
            this.userId.set(userDataObj.username);
          } else {
          }
        }
      });
  }
  postEmailSubsribe() {
    this.emailReq.set(false);

    this.emailSub.set("");
    this.postobj.set(this.emailSubsribeForm.value);

    // if (this.postobj.email) {
    //   this.emailReq=false;

    if (this.emailSubsribeForm.valid) {
      this.postobj().created_Date = new Date();
      this.postobj().updated_Date = new Date();
      this.postobj().city = this.geoLocationInfo().cityName;
      this.postobj().country_ISO_Code2 = this.geoLocationInfo().countryCode;
      this.postobj().state = this.geoLocationInfo().stateName;
      this.postobj().geoPluginCode = this.geoLocationInfo().geoPluginCode;
      this.postobj().Created_User = this.userId();
      if (this.userId) {
        this.postobj().Is_Registered_User = true;
      }
      this.commonService.postemailSubscription(this.postobj());
    } else {
      this.emailReq.set(false);

      this.commonService.validateAllFormFields(this.emailSubsribeForm);
    }

    // } else {
    //   this.emailReq = true;

    // }
  }
  ngOnDestroy() {
    this.commonService.dispose();
  }
}
